<template>
  <div style="width: 100%; display: flex" :key="Math.random()">
    <!-- <el-input :value="value" class="upload-input" clearable @clear="handleInputClear"></el-input> -->
    <!-- <div class="upload-input" @mouseenter="handlemove('in')" @mouseleave="handlemove('out')"> -->
    <el-input class="upload-input" :value="value" style="width: 100%">
      <template slot="suffix" class="inputImgWrap">
        <img class="close-icon" src="@/assets/img/delete.svg" @click="handleInputClear" v-show="value" />
      </template>
    </el-input>
    <!-- </div> -->
    <el-upload class="upload-demo" action="#" :http-request="httpRequest" :limit="1" :show-file-list="false" :before-upload="handleBeforeUpload">
      <el-button size="small" type="primary" :loading="isLoading">点击上传</el-button>
    </el-upload>
  </div>
</template>

<script>
import requestActiveLicense from '@/request/requestActiveLicense';
export default {
  props: ['value', 'index', 'licenseKeys', 'deviceUnit', 'isMaster', 'isBatch', 'isSelect'],
  data() {
    return {
      isLoading: false,
      isDelete: false,
    };
  },
  computed: {
    fileName() {
      return this.value;
    },
  },
  watch: {
    isSelect(val) {
      val && this.httpRequest();
    },
  },
  methods: {
    // 上传之前
    handleBeforeUpload(file) {
      const isLt1M = file.size < 1024 * 1024 * 1;
      if (!isLt1M) {
        this.$message.error('上传文件的大小不能超过1MB!');
        return false;
      }
    },
    // 上传函数
    httpRequest(file) {
      // 过滤多选和单选，处理licenseKey不同展示方式,多选取第一个，单选不做处理
      let licenseKey = this.isBatch ? this.licenseKeys[0] : this.licenseKeys;
      let formData = new FormData();
      if (file) {
        formData.append('file', file.file);
      } else {
        formData.append('file', '');
      }
      this.isLoading = true;
      let params = {
        licenseKey: encodeURIComponent(licenseKey),
        id: this.index,
        isMaster: this.isMaster,
        deviceUnit: this.deviceUnit,
        cacheKey: this.$store.state.cacheKey,
        processId: this.$store.state.processId,
        file: formData,
      };
      requestActiveLicense
        .uploadOldActivationFile(params)
        .then(res => {
          if (res.code === '0') {
            this.$emit('uploadCallback', res.res, this.index, this.isMaster);
          }
          this.isLoading = false;
        })
        .catch(err => {
          this.isLoading = false;
        });
    },
    // 删除文件数据
    handleInputClear(val) {
      this.$emit('fileClearCallback', '', this.index, this.isMaster);
    },
    handlemove(type) {
      if (this.value && type === 'in') {
        this.isDelete = true;
      } else {
        this.isDelete = false;
      }
    },
  },
};
</script>

<style lang="less" scoped>
.upload-demo {
  /deep/ .el-upload {
    width: 100% !important;
  }
}
.upload-input {
  flex: 1;
  margin-right: 12px;
}
.close-icon {
  width: 13px;
  position: absolute;
  right: 2px;
  top: 50%;
  transform: translateY(-50%);
  cursor: pointer;
}
</style>
